import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { LoginContext } from "./LoginContext";

const ProtectedRoute = ({ element }) => {
  const [auth] = useContext(LoginContext);
  return auth.loggedIn ? element : <Navigate to="/" replace />;
};

export default ProtectedRoute;
